import { useEffect, useRef } from "react";
import gsap from "gsap";
import BackgroundParticles from "./BackgroundParticles";

const IntroOverlay = ({ onFinish }) => {
  const overlayRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ defaults: { ease: "power3.inOut" } });

    tl.fromTo(
      titleRef.current,
      { opacity: 0, y: 40 },
      { opacity: 1, y: 0, duration: 1 }
    )
      .fromTo(
        subtitleRef.current,
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.8 },
        "-=0.5"
      )
      .to(overlayRef.current, {
        y: "-100%",
        duration: 1,
        delay: 0.5,
        onStart: () => {
            onFinish?.(); // site apparaît au début de l'animation de sortie
        }
    });
  }, [onFinish]);

  return (
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black overflow-hidden"
    >
      <BackgroundParticles />
      <div className="absolute inset-0 bg-black/70 z-0" />
      <div className="relative z-10 text-center px-4">
        <h1
          ref={titleRef}
          className="text-4xl md:text-6xl font-bold fancy-text"
        >
          Goulven RONARC'H
        </h1>
        <p
          ref={subtitleRef}
          className="mt-4 text-lg md:text-xl text-gray-300 tracking-widest uppercase"
        >
          Développeur Web - FullStack • Sportif • Ultra e-sport
        </p>
      </div>
    </div>
  );
};

export default IntroOverlay;
